export function formatPersonName(input: string | null | undefined): string {
  const raw = String(input || '').trim();
  if (!raw) return '';

  // WA often returns "Surname, GivenName". Present as "GivenName Surname".
  const commaIdx = raw.indexOf(',');
  if (commaIdx > -1) {
    const left = raw.slice(0, commaIdx).trim();
    const right = raw.slice(commaIdx + 1).trim();
    const joined = `${right} ${left}`.trim();
    return joined.replace(/\s+/g, ' ');
  }

  return raw.replace(/\s+/g, ' ');
}
